// extracted by mini-css-extract-plugin
export var active = "LanguageSwitcher-module--active--73158";
export var activeIndex = "LanguageSwitcher-module--activeIndex--0aaaf";
export var cMarginTop = "LanguageSwitcher-module--c-margin-top--ffbbd";
export var cPadding = "LanguageSwitcher-module--c-padding--3dd2e";
export var cPaddingBottom = "LanguageSwitcher-module--c-padding-bottom--396c2";
export var cPaddingTop = "LanguageSwitcher-module--c-padding-top--574ba";
export var content = "LanguageSwitcher-module--content--d0d68";
export var date = "LanguageSwitcher-module--date--45ec2";
export var disabled = "LanguageSwitcher-module--disabled--0520d";
export var dropdownMenu = "LanguageSwitcher-module--dropdownMenu--d1817";
export var dropdownToggle = "LanguageSwitcher-module--dropdownToggle--7ce31";
export var dropdownWrapper = "LanguageSwitcher-module--dropdownWrapper--60364";
export var ellipsis = "LanguageSwitcher-module--ellipsis--05a1f";
export var featuredSection = "LanguageSwitcher-module--featuredSection--6e575";
export var globalSpacing = "LanguageSwitcher-module--global-spacing--886cc";
export var globalSpacingBottom = "LanguageSwitcher-module--global-spacing-bottom--361a9";
export var globalSpacingTop = "LanguageSwitcher-module--global-spacing-top--67afe";
export var image = "LanguageSwitcher-module--image--60287";
export var imageWrapper = "LanguageSwitcher-module--imageWrapper--eceb7";
export var index = "LanguageSwitcher-module--index--3744c";
export var linkButton = "LanguageSwitcher-module--linkButton--3c898";
export var listItem = "LanguageSwitcher-module--listItem--a804d";
export var maxWidth = "LanguageSwitcher-module--max-width--e8ab8";
export var navButton = "LanguageSwitcher-module--navButton--8ca3d";
export var pagination = "LanguageSwitcher-module--pagination--84412";
export var para = "LanguageSwitcher-module--para--d8653";
export var styleTick = "LanguageSwitcher-module--styleTick--d0ab8";
export var tag = "LanguageSwitcher-module--tag--4252d";
export var tagWrapper = "LanguageSwitcher-module--tagWrapper--f5167";
export var title = "LanguageSwitcher-module--title--5bc71";